(() => {
  const root = document.querySelector('[data-sdq-root]');
  if (!root) return;
  const hero = root.querySelector('.sdq__hero');
  const updateMobileCta = () => {
    if (!hero) return;
    root.classList.toggle('sdq-show-mobile-cta', window.scrollY > hero.offsetHeight * 0.72);
  };
  updateMobileCta();
  window.addEventListener('scroll', updateMobileCta, { passive: true });
  window.addEventListener('resize', updateMobileCta);
  const nodes = root.querySelectorAll('[data-sdq-reveal]');
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    nodes.forEach((node) => node.classList.add('sdq-is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('sdq-is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  nodes.forEach((node) => observer.observe(node));
})();
